/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class CreateVehicleModalController {
        public static $inject : string[] = [
            '$mdMedia',
            '$mdDialog',
            '$mobilityCompanyAuthentication',
            '$dealerwareLoading',
            '$dealerwareNotification',
            'DealerwareVehicleModel',
            'DealerwareTrimCollection',
            '$dealerwareInternationalizationDateFormats'
        ];

        public vehicle: any;
        public trims: any;
        public onCreateSuccess: any;

        constructor(public $mdMedia: any,
                    public $mdDialog: any,
                    public auth: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public DealerwareVehicleModel: any,
                    public DealerwareTrimCollection: any,
                    public $dealerwareInternationalizationDateFormats: any) {}

        public get useFullScreen() {
            return (this.$mdMedia('xs') || this.$mdMedia('sm'));
        }

        public initModal() {
            var _self = this;

            this.vehicle = new this.DealerwareVehicleModel({});
            this.vehicle.data.license_state = this.auth.location.address.state;

            var loader = this.$dealerwareLoading.show('Please wait...');
            this.DealerwareTrimCollection.index({
                promise: true,
                params: { location_id: this.auth.location.id }
            }).then(
                function(returnValue: any) {
                    _self.trims = returnValue;
                    _self.showModal();
                },
                function(response: any) { _self.$dealerwareNotification.apiError(response); }
            ).finally(
                function() { loader.close(); }
            );
        }

        public showModal() {
            var _self = this;

            this.$mdDialog.show({
                controller: DialogController,
                templateUrl: '/components/vehicle/create/create_vehicle_modal_directive.html',
                locals: {
                    auth: this.auth,
                    vehicle: this.vehicle,
                    trims: this.trims
                },
                parent: angular.element(document.body),
                multiple: true,
                clickOutsideToClose: false,
                fullscreen: this.useFullScreen
            });

            function DialogController($scope: any, $mdDialog: any, auth: any, vehicle: any, trims: any, $dealerwareInternationalizationDateFormats: any) {
                $scope.internationalization = $dealerwareInternationalizationDateFormats.datePickerFormat();
                $scope.vehicle = vehicle;
                $scope.trims = trims;
                $scope.show_trim_picker = false;
                $scope.available_date = moment().toDate();
                $scope.saving = false;
                $scope.vehicle.data.available_date = moment($scope.available_date).format('YYYY-MM-DD');

                $scope.setAvailableDate = function() {
                    $scope.vehicle.data.available_date = moment($scope.available_date).format('YYYY-MM-DD');
                }

                $scope.saveVehicle = function() {
                    $scope.saving = true;
                    $scope.vehicle.$create({
                        promise: true,
                        params: { location_id: auth.location.id }
                    }).then(
                        function(returnValue: any) {
                            $mdDialog.hide();
                            if (_self.onCreateSuccess && angular.isFunction(_self.onCreateSuccess)) {
                                _self.onCreateSuccess({ vehicle: returnValue });
                            }
                        },
                        function(response: any) {
                            $scope.saving = false;
                            if (response.status === 400 || response.status === 404 && !$scope.vehicle.data.trim_id) {
                                _self.$dealerwareNotification.error(
                                    'Unable to look up vehicle details for VIN.  Please double check the entry or manually select a model.',
                                    { multiple: true }
                                );
                                $scope.show_trim_picker = true;
                            } else {
                                _self.$dealerwareNotification.apiError(response, undefined, { multiple: true });
                                $scope.show_trim_picker = true;
                            }
                        }
                    );
                }

                $scope.cancel = function() {
                    $mdDialog.hide();
                }
            }
        }
    }

    getDealerwareWebComponentsModule().controller('CreateVehicleModalController', CreateVehicleModalController);

    export class CreateVehicleModalDirective implements ng.IDirective {
        public restrict         : string    =   'A';
        public controller       : any       =   'CreateVehicleModalController';
        public controllerAs     : string    =   'createVehicleModalController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            onCreateSuccess: '&'
        };
        public transclude       : boolean   =   false;
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            elem :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {
            elem.bind('click', function() {
                ctrls.initModal();
            });
        }
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareCreateVehicleModal",() => new CreateVehicleModalDirective());

}
